import { SET_CHECKOUT_SHIPPING_ISCOMPLETE, SHOW_GLOBAL_ERROR, SET_GLOBAL_ISB3USER, SET_GLOBAL_ISPENDING, SET_CHECKOUT_SETTINGS } from '../actionTypes'

declare interface GlobalAction {
  type: string
  payload: any
}

export const showGlobalError = (error: Error): GlobalAction => ({
  type: SHOW_GLOBAL_ERROR,
  payload: error,
})

export const setGlobalIsB3User = (state: Boolean): GlobalAction => ({
  type: SET_GLOBAL_ISB3USER,
  payload: state,
})

export const setGlobalIsPending = (state: Boolean): GlobalAction => ({
  type: SET_GLOBAL_ISPENDING,
  payload: state,
})

export const setCheckoutSettings = (state: Boolean): GlobalAction => ({
  type: SET_CHECKOUT_SETTINGS,
  payload: state,
})


export const setCheckoutShippingIsComplete = (state: Boolean): GlobalAction => ({
  type: SET_CHECKOUT_SHIPPING_ISCOMPLETE,
  payload: state,
})